// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import 'chartkick/chart.js'
import 'bootstrap'
import { delegate } from 'jquery-events-to-dom-events'

import './client_picker'
import './slot_picker'
import './init_map'
import customConfirm from './custom_confirm'

import { application } from 'controllers/application'
import 'controllers'

const Rails = require("@rails/ujs")
Rails.start()
Rails.confirm = customConfirm
require("turbolinks").start()

global.$ = $

delegate('shown.bs.modal')

document.addEventListener("turbolinks:load", () => {
  $.fn.select2.defaults.set('theme', 'bootstrap4')

  const $newDeliveryForm = $('#new_delivery')
  if ($newDeliveryForm.length) {
    const setPhoneNumber = (value) => {
      const phoneInput = $newDeliveryForm.find('#delivery_phone')[0]
      const controller = application.getControllerForElementAndIdentifier(phoneInput, 'phone-number-input')
      controller.setRawValue(value)
    }

    $newDeliveryForm.find('select#delivery_customer_name').clientPicker(
      setPhoneNumber,
      $newDeliveryForm.find('#delivery_email'),
      $newDeliveryForm.find('#delivery_target_location_id'),
      $newDeliveryForm.find('#delivery_address2')
    )
  }

  $('.slot-picker').slotPicker()

  $('#agreements-modal').modal({
    keyboard: false,
    backdrop: 'static'
  })

  $('.timeline-toggler').on('click', (e) => {
    $(e.currentTarget).parent().next('.timeline').find('.timeline-toggable').toggleClass('d-none')
  })
})

document.addEventListener('turbolinks:before-cache', () => {
  application.controllers.forEach(controller => {
    if (typeof controller.teardown === 'function') {
      controller.teardown()
    }
  })
})
